import React, { FC } from "react";
import clsx from "clsx";

import styles from "./index.module.css";

export type TagVariant = 0 | 1 | 2 | 3;

type TagProps = {
  title?: string;
  variant: TagVariant;
};

type StatusList = {
  title?: string;
  colorClass: string;
};

const Tag: FC<TagProps> = (props) => {
  const { title, variant } = props;

  const statusList: Array<StatusList> = [
    { title: "Новый", colorClass: styles.success },
    { title: "Готов", colorClass: styles.primary },
    { title: "В обработке...", colorClass: styles.primary },
    { title: "Просмотренное", colorClass: styles.primaryLighter },
  ];

  return (
    <div className={clsx(styles.tag, statusList[variant].colorClass)}>
      {title || statusList[variant].title}
    </div>
  );
};

export default Tag;
